export const NR_ROWS = 15;
